import WaveHeroBackground from "@/components/WaveHeroBackground";
interface ProgramHeroProps {
  title: string;
  ageRange: string;
  description?: string;
}

const ProgramHero = ({ title, ageRange, description }: ProgramHeroProps) => {
  return (
    <section className="relative pt-8 sm:pt-8 md:pt-6 lg:pt-6 pb-20">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center pt-4 sm:pt-6">
          <h2 className="font-header text-2xl md:text-5xl font-bold text-[#2C003E] mb-2">
            {title}
          </h2>
          <p className="font-header text-xl text-[#2C003E]">{ageRange}</p>
          {description && (
            <p className="font-header text-xl text-[#2C003E] mt-2">{description}</p>
          )}
        </div>
      </div>
      <WaveHeroBackground maskId="program-wave-mask" />
    </section>
  );
};

export default ProgramHero;
